import { useState, useEffect, Dispatch, SetStateAction } from "react";

import { LOCAL_STORAGE_KEYS } from "@/hooks/useLocalStorageState";

export const SESSION_STORAGE_KEYS = {
  SIDEBAR_VIEW: LOCAL_STORAGE_KEYS.SIDEBAR_VIEW,
  VIBE_PANEL_POSITION: "vibe_panel_position",
  VIBE_PANEL_SIZE: "vibe_panel_size",
} as const;

const useSessionStorageState = <T>(
  key: string,
  initialValue: T,
): [T, Dispatch<SetStateAction<T>>] => {
  const [value, setValue] = useState<T>(() => {
    try {
      const storedValue = sessionStorage.getItem(key);
      return storedValue !== null ? JSON.parse(storedValue) : initialValue;
    } catch {
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch {
      // eslint-disable-next-line no-console
      console.error("Error handling session storage set item");
    }
  }, [key, value]);

  return [value, setValue];
};

export default useSessionStorageState;
